import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import searchIcon from '../../assets/search.svg'
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded, Public, Search } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import Statbox from "../Dashborad/Statbox";
import CustomTabBar from "../Utils/CustomTabBar";
import { CircleLoader } from "react-spinners";

const EventsListScreen = () => {


    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const date = new Date(isostring); // works for ISO string & ObjectId date

    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
    });
};
function CommunityListView({ data }) {
    const [locations, setlocations] = useState(null);
    const [UserLastLocation, setUserLastLocation] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedTab, setSelectedTab] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [hasEnded, setHasEnded] = useState(false)
    const [searchedEvents, setSearchedEvents] = useState([])
    const [searchQuery, setSearchQuery] = useState("")
    const [metricData, setMetricData] = useState({})
    const [loading, setLoading] = useState(false)

    const FetchEvents = async (page, type) => {

        if (page == 1) {
            setHasEnded(false)
            setEvents([])
        }
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/get-events?page=${page}&limit=${30}&type=${type}${page == 1 ? `&d_data=true` : ""}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setEvents(prev => page == 1 ? data.response : [...prev, ...data.response]);
            setCurrentPage(page)
            if (data.response.length < 30) {
                setHasEnded(true)
            }

            if (page == 1) {
                setMetricData(data.d_data ?? {})
            }
            setLoading(false);
        } else {
            setLoading(false)
        }

    };

    const SearchEvents = async (q) => {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/events/search?q=${q}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setSearchedEvents(data.data);
        }
        setLoading(false)
    };

    useEffect(() => {
        FetchEvents(1, "0");
    }, []);

    useEffect(() => {
        if (searchQuery.length > 0) {
            const delayDebounceFn = setTimeout(() => {
                SearchEvents(searchQuery);
            }, 500); // 500ms delay

            return () => clearTimeout(delayDebounceFn);
        } else {
            setSearchedEvents([]); // Clear results when input is empty
        }
    }, [searchQuery]);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [events, setEvents] = useState([])

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>

                <Box
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                >
                    <Header
                        title={`Dashboard Events`}
                        subtitle={"Manage and moniter all the events."}
                    />
                </Box>

                <Box
                    display={"grid"}
                    gridTemplateColumns="repeat(12,1fr)"
                    gridAutoRows={"100px"}
                    pb={"20px"}
                    gap={(isMobileScreen || isTabScreen) ? "20px" : "20px"}
                >
                    {/* ROW 1 */}
                    <Box
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                        sx={{
                            borderRadius: "20px",
                            border: "1.7px solid transparent",
                            background:
                                "linear-gradient(#ffffff00 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, rgba(214, 152, 36, 1)) border-box",

                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            title={metricData.totalEvents ?? 0}
                            subtitle="Total Events"
                            users={true}
                            report={0}
                        />
                    </Box>

                    <Box
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                        sx={{
                            background: "#ffffff08",
                            borderRadius: "20px",
                            border: "1.5px solid #aaaaaa05",
                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            title={metricData.totalUpcoming ?? 0}
                            subtitle="Upcoming Events"
                            loading={false}



                            users={true}
                            report={0}
                        />
                    </Box>
                    <Box
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                        sx={{
                            background: "#ffffff08",
                            borderRadius: "20px",
                            border: "1.5px solid #aaaaaa05",
                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            title={metricData.totalGlobal ?? 0}
                            subtitle="Global Events"
                            loading={false}
                            users={true}
                            report={0}
                        />
                    </Box>
                    <Box
                        sx={{
                            background: "#ffffff08",
                            borderRadius: "20px",
                            border: "1.5px solid #aaaaaa05",
                        }}
                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 3"}
                        backgroundColor={colors.primary[400]}
                        display="flex"
                        alignItems={"center"}
                        justifyContent="center"
                    >
                        <Statbox
                            // todayonboardusers
                            title={metricData.totalPaid ?? 0}
                            subtitle="Paid Events"
                            onClick={() => {

                            }}

                            users={true}
                        />
                    </Box>

                    {/* ROW 2 */}




                </Box>


                <Box sx={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: "center",
                    marginBottom: "20px",
                }}>
                    <Box sx={{
                        flexDirection: 'row',
                        display: 'flex',
                        borderRadius: "15px",
                        border: "1px solid #aaaaaa10",
                        background: "#ffffff08",
                        maxWidth: isMobileScreen ? "100%" : isTabScreen ? "80%" : "32.5%",
                        minWidth: isMobileScreen ? "100%" : "500px"
                    }}>

                        <img
                            alt="search_icon"
                            width="20px"
                            height="20px"
                            style={{
                                objectFit: 'contain',
                                filter: 'invert(1) hue-rotate(180deg) brightness(1)',
                                alignSelf: 'center',
                                marginLeft: "15px"
                            }}
                            src={searchIcon}
                        />
                        <input
                            placeholder="Search a event by name..."
                            enterKeyHint={'search'}
                            value={searchQuery}
                            // onKeyDown={(e) => {
                            //     if (e.key === "search" || e.key === "enter") {
                            //         searchEvent(e.target.value)
                            //         e.target.value = "";
                            //     }
                            // }}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                outline: 'none',
                                backgroundColor: "transparent",
                                borderWidth: 0,
                                padding: "15px 15px",
                                flex: 1,
                                fontSize: "14px",
                                fontFamily: 'poppins-reg',
                                color: "white"
                            }}
                        />


                    </Box>


                </Box>



                <CustomTabBar
                    selectedTab={selectedTab}
                    tabs={["All Events", "Paid Events", "Global Events", "Expired Events"]}
                    marginBottom="10px"
                    gap={isMobileScreen ? "12px" : "15px"}
                    fontSize={isMobileScreen ? "15px" : "18px"}
                    nonSelectedFontSize={isMobileScreen ? "12px" : "13px"}
                    marginLeft="5px"
                    onChange={(index) => {
                        setSelectedTab(index)
                        FetchEvents(1, `${index}`)
                    }}

                />



                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>

                    <Box
                        display={"flex"}
                        gap="20px"
                        sx={{
                            flexWrap: 'wrap',
                            flexDirection: 'row'
                        }}
                        pb={"20px"}
                    >
                        {
                            (searchQuery.length > 0 ? searchedEvents : events).map((community) => {
                                return (
                                    <Box
                                        // key={`${transaction.txId}-${i}`}

                                        display="flex"
                                        component={Link}
                                        borderRadius={"10px"}
                                        to={{
                                            pathname: "/admin/event-details",
                                            search: `?event=${community._id}`,
                                            state: { fromDashboard: true },
                                            // console.log(first)
                                        }}

                                        sx={{
                                            textDecoration: 'none', flexDirection: 'column',
                                            display: 'flex', width: isMobileScreen ? "182px" : "240px"
                                        }}
                                    >
                                        <Box sx={{
                                            display: 'flex', alignItems: 'center', alignSelf: 'stretch',
                                            position: "relative", flexDirection: "column"
                                        }}>
                                            <img
                                                alt="profile-user"
                                                width={"100%"}
                                                src={`${community.banner}`}
                                                style={{
                                                    aspectRatio: 1 / 1,
                                                    cursor: "pointer", objectFit: 'cover',
                                                    borderRadius: "15px",
                                                    border: "2px solid #ffffff05"
                                                }}
                                            />

                                            <Box sx={{ width: "100%", height: "100%", position: "absolute", background: "#00000010" }} />

                                            <Box sx={{
                                                display: "flex", flexDirection: "column", background: "#0f0f0f", position: "absolute",
                                                margin: "10px", borderRadius: "11px",
                                                paddingInline: "10px", paddingBlock: "5px", alignSelf: "flex-end", alignItems: "center",
                                                border: "1px solid #aaaaaa20"
                                            }}>


                                                <Typography color={"#ffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                    }}
                                                    fontSize={"11.5px"}>{Convert_Time_Zone(community.startDate)}</Typography>

                                            </Box>

                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: "10px" }}>
                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                fontSize={"14px"}
                                                style={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 1,      // change to 3,4 if needed
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden"
                                                }}
                                            >{community.title}</Typography>

                                            <Typography color={"#aaaaaa"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    marginTop: "2px",
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 1,      // change to 3,4 if needed
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden"
                                                }}
                                                fontSize={"11px"}>{community.locationName}</Typography>


                                            <Box sx={{ flexDirection: "row", alignItems: "center", display: "flex", gap: "5px" }} >
                                                {
                                                    community.isGlobal && (<Public style={{
                                                        fontSize: "20px", marginTop: "5px",
                                                        display: "-webkit-box",
                                                        background: "#ffffff10",
                                                        paddingInline: "4px",
                                                        color: "#ffffff90",
                                                        borderRadius: "4px",
                                                        alignSelf: "flex-start",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        WebkitLineClamp: 1,      // change to 3,4 if needed
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden"
                                                    }} />
                                                    )}

                                                {
                                                    community.isPaid && (<Typography color={"#ff8800"}
                                                        fontFamily={"poppins-reg"}
                                                        style={{
                                                            marginTop: "5px",
                                                            display: "-webkit-box",
                                                            background: "#ff880020",
                                                            paddingInline: "8px",
                                                            borderRadius: "4px",
                                                            paddingBlock: "2px",
                                                            alignSelf: "flex-start",
                                                            WebkitLineClamp: 1,      // change to 3,4 if needed
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden"
                                                        }}
                                                        fontSize={"11px"}>Paid</Typography>
                                                    )}



                                                {
                                                    (community.registered.length ?? 0) > 0 && (
                                                        <Typography color={"#ffffff90"}
                                                            fontFamily={"poppins-reg"}
                                                            style={{
                                                                marginTop: "5px",
                                                                display: "-webkit-box",
                                                                background: "#ffffff10",
                                                                paddingInline: "8px",
                                                                borderRadius: "4px",
                                                                paddingBlock: "2px",
                                                                alignSelf: "flex-start",
                                                                WebkitLineClamp: 1,      // change to 3,4 if needed
                                                                WebkitBoxOrient: "vertical",
                                                                overflow: "hidden"
                                                            }}
                                                            fontSize={"11px"}>{community.registered.length ?? 0} registrations</Typography>
                                                    )
                                                }





                                            </Box>

                                        </Box>

                                    </Box>
                                );
                            })}
                    </Box>


                    {
                        hasEnded && !loading && (
                            <Box  sx={{
                                alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                fontFamily: "poppins-reg", fontSize: "12px", color: "#ffffff90"
                            }} >- Looks like you have reached to the end -</Box>
                        )
                    }

                    {
                        !hasEnded && !loading && (
                            <Box onClick={() => {
                                if (!hasEnded) {
                                    FetchEvents(currentPage + 1, `${selectedTab}`)
                                }
                            }} sx={{
                                alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                fontFamily: "poppins-reg", fontSize: "13px", borderRadius: "10px", border: "1px solid #943bff",
                                background: "#943bff20", cursor: "pointer",
                            }} >Load More</Box>
                        )
                    }

                </Box>

            </Box>
        </>
    );
}

export default EventsListScreen;
